module.exports = __webpack_public_path__ + "static/media/devices.c8878a78.png";